import { createContext, useContext } from 'react';

const ProductsNavigationContext = createContext<Record<string, () => void>>({});

export const useProductsNavigation = <Path extends string>(navigation: Path): (() => void) => {
    const navigations = useContext(ProductsNavigationContext);

    if (Object.keys(navigations).length === 0) {
        throw new Error('The hook is used outside of a NavigationContext');
    }

    if (!navigations[navigation]) {
        throw new Error('The desired navigation does not exists');
    }

    return navigations[navigation];
};

export const ProductsNavigationProvider = ProductsNavigationContext.Provider;
